import React, { useState } from "react";
import { toast } from "sonner";
import { HelpCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from "@/components/ui/dialog";
import { Textarea } from "@/components/ui/textarea";
import api from "@/lib/api";

export function AskQuestionButton({ targetType, targetId, targetName, className, variant = "secondary", full = true }) {
  const [open, setOpen] = useState(false);
  const [body, setBody] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    if (!body.trim()) return;
    setBusy(true);
    try {
      await api.post("/questions", { target_type: targetType, target_id: targetId, body: body.trim() });
      toast.success("Your question was sent.");
      setOpen(false); setBody("");
    } catch (e) {
      toast.error((e && e.response && e.response.data && e.response.data.detail) || "Could not send question");
    } finally { setBusy(false); }
  };

  return (
    <>
      <Button variant={variant} className={`${full ? "w-full justify-start" : ""} ${className || ""}`} onClick={() => setOpen(true)} data-testid="ask-question-button">
        <HelpCircle className="mr-2 h-4 w-4" /> Ask a Question
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Ask a question</DialogTitle>
            <DialogDescription>{targetName ? `Send a question to ${targetName}. They can choose to publish their answer.` : "Send a question to this profile owner."}</DialogDescription>
          </DialogHeader>
          <Textarea value={body} onChange={(e) => setBody(e.target.value.slice(0, 300))} maxLength={300} rows={4} placeholder="What would you like to ask?" data-testid="ask-question-input" />
          <div className="text-right text-xs tabular-nums text-muted-foreground" data-testid="ask-question-count">{body.length}/300</div>
          <DialogFooter>
            <Button variant="secondary" onClick={() => setOpen(false)}>Cancel</Button>
            <Button onClick={submit} disabled={busy || !body.trim()} data-testid="ask-question-submit">Send question</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
}
